var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" 404 NOT FOUND"),_c('br'),_vm._v(" Go to "),_c('router-link',{attrs:{"to":{name: 'Dashboard'}}},[_vm._v("dashboard!")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }